<template>
  <div class="editorial">
    <div class="editorial_nav">
      <div class="Surgery_detailstop">
        <div class="editorial_txt">
          <div class="iconfont iconhomeicon evolution_tu" style="margin-right: 5px;"></div>
          <div class="editorial_txt2" style="cursor: pointer;" @click="tiao">
            首页 <span class="span1">></span><span @click.stop="tiao2">视频/课件</span><span class="span1">></span><span class="span2">视频详情</span>
          </div>
        </div>
        <div class="Surgery_detailstopl">
         <video id="my-video" :src="data.filePath" :poster="data.titlePhoto" class="video-js vjs-default-skin vjs-big-play-centered vjs-16-9" controls preload="auto" webkit-playsinline="true" playsinline="true" type="application/x-mpegURL" allowsInlineMediaPlayback=YES  webview.allowsInlineMediaPlayback=YES  width='100%' ref='videoRef' x5-video-player-fullscreen="true"></video>
        </div>
        <div class="Surgery_detailstopr" style="margin-top: 20px;">
          <div class="Surgery_txt1">{{data.title}}</div>
          <div class="Surgery_txt2">讲者：{{data.author}}</div>
          <div class="Surgery_txt3">单位：{{data.organization}}</div>
          <div class="Surgery_txt4">
            <div class="Surgery_txt4l"><span class="iconfont iconrentou" style="margin-right: 10px;"></span>{{data.hitCount}}人在看</div>
            <div class="Surgery_txt4r">{{data.addDate}}</div>
          </div>
<!--          <div class="Surgery_txt5">
            <div v-for="(item,index) in biaoqian" :key="index">{{item.txt}}</div>
          </div> -->
          <div class="Surgery_btn" @click="play">立即播放</div>
        </div>
      </div>
    </div>
    <div class="Surgery_xia">
      <div style="width: 100%;height: 22px;background-color: #FAFAFA;"></div>
      <div class="editorial_nav">
        <div class="editorial_left" style="padding-top: 0;">
          <div class="express_rtitle">
            <div class="waike">课程介绍</div>
            <div class="waixian"></div>
          </div>
          <div class="Surgery_details">
            <div class="Surgery_detailstxt2" v-html="data.content"></div>
          </div>
        </div>
        <div class="editorial_right">
          <advertisement :num="num" :list2="list2" :video="video"></advertisement>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//配置右侧广告栏
import advertisement from "../public/evolution/advertisement.vue"

export default {
  components:{
    advertisement
  },
  data () {
    return {
      data: [],//视频数据
      biaoqian: [
        {
          id: 1,
          txt: '肝切除术'
        },
        {
          id: 1,
          txt: '肝门部'
        },
        {
          id: 1,
          txt: '胆管癌'
        },
        {
          id: 1,
          txt: '门静脉'
        },
      ],
      num:{
        wai: false,
        zixun: false,
        xia: false,
        look: false,
        video: false,
        video2: true,
      },//控制广告栏的显示隐藏
      list2: [
        {
          id: 1,
          txt: '多西他赛对进展期胃癌术后化疗疗效影响向...'
        },
        {
          id: 2,
          txt: '中国腹腔镜减重代谢外科20年研究文献分析...'
        }
      ],//外科天地
      list: [
        {
          id: 1,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗123',
          time: '2020-03-25'
        },
        {
          id: 2,
          txt: '中国腹腔镜减重代谢外科20年研究中国腹腔镜减重代谢外科20年研究',
          time: '2020-03-25'
        },
        {
          id: 3,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 4,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 5,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 6,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 7,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 8,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 9,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 10,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗123',
          time: '2020-03-25'
        },
        {
          id: 11,
          txt: '中国腹腔镜减重代谢外科20年研究中国腹腔镜减重代谢外科20年研究',
          time: '2020-03-25'
        },
        {
          id: 12,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 13,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 14,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 15,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 16,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 17,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        }
      ],//浏览排行
      video: [
        {
          id: 1,
          name: '王某',
          txt: '三维可视化精确评估累及腹腔多脏器的特大腹膜后脂肪肉瘤切除术',
          address: '上海交通大学医学院附属瑞金医院',
          time: '2020-01-10',
          num: 1096
        },
        {
          id: 2,
          name: '王某',
          txt: '三维可视化精确评估累及腹腔多脏器的特大腹膜后脂肪肉瘤切除术',
          address: '上海交通大学医学院附属瑞金医院',
          num: 1096
        },
        {
          id: 3,
          name: '王某',
          txt: '三维可视化精确评估累及腹腔多脏器的特大腹膜后脂肪肉瘤切除术',
          address: '上海交通大学医学院附属瑞金医院',
          num: 1096
        },
        {
          id: 4,
          name: '王某',
          txt: '三维可视化精确评估累及腹腔多脏器的特大腹膜后脂肪肉瘤切除术',
          address: '上海交通大学医学院附属瑞金医院',
          num: 1096
        },
        {
          id: 5,
          name: '王某',
          txt: '三维可视化精确评估累及腹腔多脏器的特大腹膜后脂肪肉瘤切除术',
          address: '上海交通大学医学院附属瑞金医院',
          num: 1096
        },
        {
          id: 6,
          name: '王某',
          txt: '三维可视化精确评估累及腹腔多脏器的特大腹膜后脂肪肉瘤切除术',
          address: '上海交通大学医学院附属瑞金医院',
          num: 1096
        },
        {
          id: 7,
          name: '王某',
          txt: '三维可视化精确评估累及腹腔多脏器的特大腹膜后脂肪肉瘤切除术',
          address: '上海交通大学医学院附属瑞金医院',
          num: 1096
        },
        {
          id: 8,
          name: '王某',
          txt: '三维可视化精确评估累及腹腔多脏器的特大腹膜后脂肪肉瘤切除术',
          address: '上海交通大学医学院附属瑞金医院',
          num: 1096
        },
        {
          id: 9,
          name: '王某',
          txt: '三维可视化精确评估累及腹腔多脏器的特大腹膜后脂肪肉瘤切除术',
          address: '上海交通大学医学院附属瑞金医院',
          num: 1096
        }
      ],//发展大事记
    }
  },
  watch:{
    '$route'(to,from){
      this.GetContentInfo(this.$route.query.contentId);
    }
  },
  methods:{
      tiao2(){
        this.$router.push({path:'/surgery'});
      },
      tiao(){
        this.$router.push({path:'/home'});
      },
      //视频播放按钮
      play(){
        this.$refs.videoRef.play();
      },
      //视频详情
      GetContentInfo(contentId){
        var that = this;
        that.$httphelper.GetContentInfo({
          "journalId": that.$_JournalId,
          "year":  0,
          "issue": 0,
          "channelId": 0,
          "contentId": Number(contentId),
          "dataSourceType": 2,
          "dataShowType": 1
        }).then(res => {
          if(res.code==200){
            that.data = res.data.bmpVideoCourseResult || '';
            that.$loading.hideLoading();
          }else{
            that.$alert(res.msg, '提示', {
              confirmButtonText: '确定',
              callback: action => {

              }
            });
          }
        });
      },
      index(){
        sessionStorage.setItem('routerIndex',8);
        this.total = this.list.length;
        this.GetContentInfo(this.$route.query.contentId);
      },
      //鼠标悬停
      addtop(num,id){
        if(num==1){
          for(var i=0;i<this.list.length;i++){
            if(id==this.list[i].id){
              this.list[i].zt = true;
              this.list.push('1');
              this.list.pop('1');
            }
          }
        }else{
          for(var i=0;i<this.list.length;i++){
            this.list[i].zt = false;
            this.list.push('1');
            this.list.pop('1');
          }
        }
      },
  },
  created(){
    this.index();
  }
}
</script>

<style lang="scss" scoped>
*{
    margin: 0;
    padding: 0;
}
.editorial{
  width: 100%;
  min-width: 1200px;
  background-color: #FFFFFF;
  .editorial_nav{
    width: 85%;
    margin: 0 auto;
    overflow: hidden;
    padding-top: 30px;
    .Surgery_detailstop{
      width: 100%;
      overflow: hidden;
      padding-bottom: 47px;
      .Surgery_detailstopl{
        width: 50%;
        float: left;
        img{
          width: 100%;
          height: 450px;
          object-fit: cover;
        }
        img:hover{
          transform: scale(1.03);
        }
      }
      .Surgery_detailstopr{
        width: 47.5%;
        padding-left: 2.5%;
        float: left;
        .Surgery_txt1{
          width: 100%;
          font-size: 24px;
          font-family: Adobe Heiti Std;
          font-weight: bold;
          color: #000000;
          line-height: 28px;
          margin-bottom: 25px;
        }
        .Surgery_txt2,.Surgery_txt3{
          font-size: 16px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #909090;
        }
        .Surgery_txt3{
          margin-top: 20px;
        }
        .Surgery_txt4{
          width: 100%;
          overflow: hidden;
          margin-top: 28px;
          margin-bottom: 40px;
          .Surgery_txt4l,.Surgery_txt4r{
            float: left;
            width: 50%;
            font-size: 16px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #909090;
          }
          .Surgery_txt4r{
            text-align: right;
          }
        }
        .Surgery_txt5{
          width: 100%;
          overflow: hidden;
          div{
            width: auto;
            display: inline-block;
            padding: 0 28px;
            margin-right: 18px;
            height: 34px;
            line-height: 34px;
            background: #FFE7DF;
            border-radius: 17px;
            font-size: 16px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: var(--xt);
            text-align: center;
          }
        }
        .Surgery_btn{
          cursor: pointer;
          width: 220px;
          height: 52px;
          background: var(--xt);
          text-align: center;
          line-height: 52px;
          font-size: 18px;
          font-family: Adobe Heiti Std;
          font-weight: bold;
          color: #FFFFFF;
          margin-top: 137px;
        }
      }
    }
    .editorial_left{
      width: 72%;
      margin-right: 3%;
      float: left;
      padding-top: 35px;
      .express_rtitle {
        width: 100%;
        overflow: hidden;
        border-bottom: 3px solid #DBDBDB;
        padding-bottom: 11px;
        position: relative;
        margin-bottom: 42px;
        .waike {
          width: 50%;
          float: left;
          font-size: 20px;
          font-family: Source Han Sans SC;
          font-weight: bold;
          color: #000000;
          line-height: 23px;
        }
        .waixian {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100px;
          height: 3px;
          background: var(--biao);
        }
      }
      .Surgery_details{
        width: 100%;
        .Surgery_detailstxt1{
          font-size: 16px;
          font-family: Source Han Sans SC;
          font-weight: bold;
          color: #000000;
          margin: 30px 0;
        }
        .Surgery_detailstxt2{
          font-size: 16px;
          font-family: Source Han Sans SC;
          font-weight: 400;
          color: #000000;
        }
      }
    }
    .editorial_right{
      width: 25%;
      float: left;
    }
  }
  .Surgery_xia{
    width: 100%;
    .editorial_nav{
      width: 85%;
      margin: 0 auto;
      overflow: hidden;
      padding-bottom: 79px;
      .Surgery_detailstop{
        width: 100%;
        overflow: hidden;
        padding-bottom: 47px;
        .Surgery_detailstopl{
          width: 50%;
          float: left;
          img{
            width: 100%;
            height: 450px;
            object-fit: cover;
          }
          img:hover{
            transform: scale(1.03);
          }
        }
        .Surgery_detailstopr{
          width: 48%;
          padding-left: 2%;
          float: left;
          .Surgery_txt1{
            width: 100%;
            font-size: 24px;
            font-family: Adobe Heiti Std;
            font-weight: bold;
            color: #000000;
            line-height: 28px;
            margin-bottom: 25px;
          }
          .Surgery_txt2,.Surgery_txt3{
            font-size: 16px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #909090;
          }
          .Surgery_txt3{
            margin-top: 20px;
          }
          .Surgery_txt4{
            width: 100%;
            overflow: hidden;
            margin-top: 28px;
            margin-bottom: 40px;
            .Surgery_txt4l,.Surgery_txt4r{
              float: left;
              width: 50%;
              font-size: 16px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #909090;
            }
            .Surgery_txt4r{
              text-align: right;
            }
          }
          .Surgery_txt5{
            width: 100%;
            overflow: hidden;
            div{
              width: auto;
              display: inline-block;
              padding: 0 28px;
              margin-right: 18px;
              height: 34px;
              line-height: 34px;
              background: #FFE7DF;
              border-radius: 17px;
              font-size: 16px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: var(--xt);
              text-align: center;
            }
          }
          .Surgery_btn{
            width: 220px;
            height: 52px;
            background: var(--xt);
            text-align: center;
            line-height: 52px;
            font-size: 18px;
            font-family: Adobe Heiti Std;
            font-weight: bold;
            color: #FFFFFF;
          }
        }
      }
      .editorial_left{
        width: 72%;
        margin-right: 3%;
        float: left;
        padding-top: 35px;
        .express_rtitle {
          width: 100%;
          overflow: hidden;
          border-bottom: 3px solid #DBDBDB;
          padding-bottom: 11px;
          position: relative;
          .waike {
            width: 50%;
            float: left;
            font-size: 20px;
            font-family: Source Han Sans SC;
            font-weight: bold;
            color: #000000;
            line-height: 23px;
          }
          .waixian {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100px;
            height: 3px;
            background: var(--biao);
          }
        }
        .Surgery_details{
          width: 100%;
          .Surgery_detailstxt1{
            font-size: 16px;
            font-family: Source Han Sans SC;
            font-weight: bold;
            color: #000000;
            margin: 30px 0;
          }
          .Surgery_detailstxt2{
            font-size: 16px;
            font-family: Source Han Sans SC;
            font-weight: 400;
            color: #000000;
          }
        }
      }
      .editorial_right{
        width: 25%;
        float: left;
      }
    }
  }
}
.add1 {
  color: var(--xt) !important;
  text-decoration: underline;
}

.add2 {
  background-color: var(--xt) !important;
}


    .editorial_txt{
      width: 100%;
      // margin-top: 24px;
      margin-bottom: 26px;
      overflow: hidden;
      .evolution_tu{
        width: 19px;
        height: 17px;
        float: left;
      }
      .editorial_txt2{
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #010101;
        .span1 {
          margin: 0 5px;
        }
        .span2 {
          color: var(--xt);
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/secondary/Surgery_details.vue